import { forwardRef, type Ref, type SVGProps } from "react";
const IconKeyboardFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M29 6H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1m-14 4h2v2h-2Zm0 4h2v2h-2Zm-4-4h2v2h-2Zm0 4h2v2h-2Zm-2 6H7v-2h2Zm0-4H7v-2h2Zm0-4H7v-2h2Zm12 8H11v-2h10Zm0-4h-2v-2h2Zm0-4h-2v-2h2Zm4 8h-2v-2h2Zm0-4h-2v-2h2Zm0-4h-2v-2h2Z" /></svg>;
const ForwardRef = forwardRef(IconKeyboardFilledSVG);
ForwardRef.displayName = "IconKeyboardFilled";
export { ForwardRef as IconKeyboardFilled };